"use strict";
exports.__esModule = true;
exports.SDS_CONNECTION_NAME = exports.SET_CONTEXT = exports.ENVIRONMENTS = exports.CUSTOMER_GROUPS = exports.TRACKING_CLICK_ACTION = exports.TRACKING_CLICK_LABEL = exports.CONTEXT_TYPES = exports.THEME = exports.ORIENTATION = exports.INTEGRATION_TYPES = void 0;
var INTEGRATION_TYPES;
(function (INTEGRATION_TYPES) {
    INTEGRATION_TYPES["AEM"] = "AEM";
    INTEGRATION_TYPES["STANDALONE"] = "STANDALONE";
})(INTEGRATION_TYPES = exports.INTEGRATION_TYPES || (exports.INTEGRATION_TYPES = {}));
var ORIENTATION;
(function (ORIENTATION) {
    ORIENTATION["LTR"] = "ltr";
    ORIENTATION["RTL"] = "rtl";
})(ORIENTATION = exports.ORIENTATION || (exports.ORIENTATION = {}));
var THEME;
(function (THEME) {
    THEME["LIGHT"] = "light";
    THEME["DARK"] = "dark";
})(THEME = exports.THEME || (exports.THEME = {}));
var CONTEXT_TYPES;
(function (CONTEXT_TYPES) {
    CONTEXT_TYPES["B2B"] = "B2B";
    CONTEXT_TYPES["B2C"] = "B2C";
})(CONTEXT_TYPES = exports.CONTEXT_TYPES || (exports.CONTEXT_TYPES = {}));
var TRACKING_CLICK_LABEL;
(function (TRACKING_CLICK_LABEL) {
    TRACKING_CLICK_LABEL["B2B"] = "toggle.business";
    TRACKING_CLICK_LABEL["B2C"] = "toggle.private";
})(TRACKING_CLICK_LABEL = exports.TRACKING_CLICK_LABEL || (exports.TRACKING_CLICK_LABEL = {}));
var TRACKING_CLICK_ACTION;
(function (TRACKING_CLICK_ACTION) {
    TRACKING_CLICK_ACTION["AEM"] = "customer_type_context.switch";
    // In the future they could be different.
    TRACKING_CLICK_ACTION["STANDALONE"] = "customer_type_context.switch";
})(TRACKING_CLICK_ACTION = exports.TRACKING_CLICK_ACTION || (exports.TRACKING_CLICK_ACTION = {}));
var CUSTOMER_GROUPS;
(function (CUSTOMER_GROUPS) {
    CUSTOMER_GROUPS["B2C_DEFAULT"] = "B2C_DEFAULT";
    CUSTOMER_GROUPS["B2B_DEFAULT"] = "B2B_DEFAULT";
})(CUSTOMER_GROUPS = exports.CUSTOMER_GROUPS || (exports.CUSTOMER_GROUPS = {}));
var ENVIRONMENTS;
(function (ENVIRONMENTS) {
    ENVIRONMENTS["DEV"] = "dev";
    ENVIRONMENTS["TEST"] = "test";
    ENVIRONMENTS["INT"] = "int";
    ENVIRONMENTS["PPROD"] = "pprod";
    ENVIRONMENTS["PROD"] = "prod";
})(ENVIRONMENTS = exports.ENVIRONMENTS || (exports.ENVIRONMENTS = {}));
exports.SET_CONTEXT = 'setContext';
exports.SDS_CONNECTION_NAME = 'CSCS_USER_CONTEXT_MANAGER';
